import { h, Component, AnyComponent } from 'preact'
import { abTest, ABTestsInProgress } from '../../../src/services/abTest'

export type Version = 'A' | 'B'

interface ABTestProps {
  version: Version
}

export default function WithABTest<P extends ABTestProps> (WrappedComponent: AnyComponent<P>, feature: ABTestsInProgress) {
  return class ABTest extends Component<Omit<P, 'version'>> {
    version: Version

    constructor () {
      super()
      this.version = abTest(feature)
    }

    render () {
      // @ts-expect-error  https://github.com/Microsoft/TypeScript/issues/28938
      return <WrappedComponent {...this.props} version={this.version} />
    }
  }
}
